
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import ReactPaginate from 'react-paginate';
import Tooltip from 'react-tooltip';
import { MdDelete, MdFileDownload, MdFileUpload, MdModeEdit, MdSearch } from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { FaListAlt } from 'react-icons/fa';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill } from "react-icons/bs";
import { Button } from "react-bootstrap";
import ModalSendCertificate from '../CandidatosVinculados/ModalSendCertificate';

class Certificados extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: false,
            certificados: [],
            pagination: {
                page: 1,
                last_page: 1,
            },
            msgErro: '',
            show_warning: false,
            show_erro: false,
            unidade_to_delete: '',
            search: '',
            loading_search: true,
            selectedCandidatoCertificate:null,
            showModalCertificate:false,
            loadingPlanilha: null
        };
    }






    componentDidMount() {

        this.get_certificados(this.state.pagination.page);
    }

    get_certificados(page, search = '', busca = true) {
        if (busca == true) {
            if (this.state.loading_search == false) {
                this.setState({ loading_search: true });
            }
        }
        else if (this.state.loading_screen === false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_certificados?page=${page}&search=${search}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });
                }
                else {
                    this.setState({ loading_search: false, certificados: resp.certificados, loading_screen: false, pagination: resp.pagination });
                    console.log("paginaiton é: ", this.state.pagination, "contents é: ", this.state.contents)

                }
            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);
            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }

    downloadPlanilha(nivel) {
        this.setState({ loadingPlanilha: nivel });

        fetch(`${URL}api/faculdade/download_certificados_planilha/${nivel}`, {
            method: 'GET',
            headers: {
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${this.props.token}`,
            }
        }).then(async (response) => {
            if (response.status === 401) {
                localStorage.removeItem('token'); localStorage.removeItem('user');
                this.props.logout();
                return;
            }

            if (!response.ok) {
                let resp = await response.json().catch(() => ({}));
                this.setState({
                    msgErro: resp.message || 'Não foi possível baixar a planilha.',
                    show_erro: true,
                });
                return;
            }

            const blob = await response.blob();
            const filename = nivel === 'medio'
                ? 'certificados_ensino_medio.xlsx'
                : 'certificados_ensino_fundamental.xlsx';
            const href = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(href);
        }).catch((err) => {
            console.log(err);
            this.setState({
                msgErro: 'Não foi possível baixar a planilha.',
                show_erro: true,
            });
        }).finally(() => {
            this.setState({ loadingPlanilha: null });
        });
    }

    renderNotasAreas(notasAreas) {
        const labels = {
            linguagens: 'Linguagens',
            redacao: 'Redação',
            matematica: 'Matemática',
            humanas: 'Humanas',
            natureza: 'Natureza',
        };

        if (!notasAreas || Object.keys(notasAreas).length === 0) {
            return '-';
        }

        return (
            <div style={{ minWidth: 190 }}>
                {Object.keys(labels).map((key) => {
                    const area = notasAreas[key];
                    if (!area) return null;
                    const aprovado = area.resultado === 'Aprovado';
                    return (
                        <p key={key} style={{ marginBottom: 2, fontSize: 12 }}>
                            <b>{labels[key]}:</b> {area.nota} <span style={{ color: aprovado ? 'green' : 'red' }}>({area.resultado})</span>
                        </p>
                    );
                })}
            </div>
        );
    }










    render() {
        console.log(this.props.user?.empresa)
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">

                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Certificados</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados todos os certificados</p>
                            <br />
                            <br />

                            {this.state.show_erro == true && <SweetAlert danger title="Erro" onConfirm={() => this.setState({ show_erro: false, msgErro: '' })}>
                                {this.state.msgErro}
                            </SweetAlert>}

                             <ModalSendCertificate 
                        showModal={this.state.showModalCertificate} 
                        setShowModal={(e)=>this.setState({showModalCertificate:e})} 
                        candidato={this.state.selectedCandidatoCertificate} 
                        processo_id={this.state.selectedCandidatoCertificate?.processo_id}
                    />

                            <div className="row">

                                <div className="col-12">


                                    {/* <hr /> */}
                                    {this.state.loading_screen == false && <div>

                                        {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                                        {/* <br /> */}

                                        <div className="flex jcsb flex-wrap mb-4">

                                            <Search placeholder="Pesquisar pelo CPF do candidato" ValueChange={value => {
                                                clearTimeout(this.pesquisarTimeout);
                                                this.pesquisarTimeout = setTimeout(() => {
                                                    let page = { ...this.state.pagination };
                                                    page.current_page = 1;
                                                    this.setState({ pagination: page, search: value, loading_search: true });
                                                    this.get_certificados(1, value);
                                                }, 500);
                                            }} />

                                            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
                                                <Button
                                                    variant="success"
                                                    className="flex align-center jcc"
                                                    disabled={this.state.loadingPlanilha !== null}
                                                    onClick={() => this.downloadPlanilha('medio')}
                                                >
                                                    {this.state.loadingPlanilha === 'medio' ? <CircularProgress size={18} style={{ marginRight: 10, color: 'white' }} /> : <MdFileDownload style={{ marginRight: 10 }} />}
                                                    <p style={{ margin: 0 }}>Baixar planilha do ensino médio</p>
                                                </Button>
                                                <Button
                                                    variant="success"
                                                    className="flex align-center jcc"
                                                    disabled={this.state.loadingPlanilha !== null}
                                                    onClick={() => this.downloadPlanilha('fundamental')}
                                                >
                                                    {this.state.loadingPlanilha === 'fundamental' ? <CircularProgress size={18} style={{ marginRight: 10, color: 'white' }} /> : <MdFileDownload style={{ marginRight: 10 }} />}
                                                    <p style={{ margin: 0 }}>Baixar planilha do ensino fundamental</p>
                                                </Button>
                                            </div>



                                        </div>

                                        <div className="table-rep-plugin">
                                            <div className="table-responsive mb-0" data-pattern="priority-columns">
                                                <table id="tech-companies-1" className="table table-striped">
                                                    <thead>
                                                        <tr>

                                                            <th>Nome do candidato</th>
                                                            <th>CPF</th>
                                                            <th>Agendamento</th>

                                                            {<th>Tipo</th>}
                                                            <th>Notas por área</th>

                                                            <th data-priority="3">Ações</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.loading_search == false && this.state.certificados.map((item, id) => (

                                                            <tr key={id}>
                                                                {<td>{item.owner.name}</td>}
                                                                {<td>{item.owner.cpf}</td>}
                                                                {<td>{item.processo_seletivo.name}</td>}

                                                                {<td>{item.name.includes('Declara') ? 'Declaração' : 'Certificado'}</td>}
                                                                {<td>{this.renderNotasAreas(item.notas_areas)}</td>}




                                                                {/* <td>Questão {id + 1}</td> */}
                                                                <td >
                                                                    <span
                                                                        onClick={() => {
                                                                            this.setState({selectedCandidatoCertificate:{...item.owner,processo_id:item.processo_seletivo.id},showModalCertificate:true})
                                                                        }}
                                                                        className="inline-flex align-center jcc bg-primary icon"
                                                                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                                        title="Enviar Certificado"
                                                                    >
                                                                        <MdFileDownload size={17} color="white" />
                                                                    </span>



                                                                </td>

                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        {this.state.loading_search == true &&

                                            <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                                <CircularProgress />
                                            </div></div>

                                        }
                                        {this.state.loading_search == false && this.state.certificados.length == 0 && <div className="row w-100">
                                            <div className="col-12">
                                                <p style={{ textAlign: 'center' }}>Nenhum documento encontrado</p>

                                            </div>
                                        </div>}

                                        <Pagination
                                            className={(this.state.pagination.last_page == 1 ? "hide" : "")}
                                            style={{ display: "flex", justifyContent: "flex-end" }}
                                            count={this.state.pagination.last_page}
                                            value={this.state.pagination.current_page}
                                            onChange={(_, value) => {
                                                console.log(_, value);
                                                let page = { ...this.state.pagination };
                                                page.current_page = value;
                                                this.setState({ pagination: page });
                                                this.get_certificados(value, this.state.search);
                                            }}
                                        />

                                        {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                                    </div>}

                                    {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                        {/* <div className="spinner-border text-primary" role="status"  >
        </div> */}
                                        <CircularProgress />
                                    </div></div>}




                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user,
        token: state.AppReducer.token,
    }
);

export default connect(mapsStateToProps, { logout })(Certificados);
